import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ccaa_actions } from "../../store/ccaa_slice";
import { FileUploader } from "react-drag-drop-files";
import { storage } from "../../firebase";
import {
  ref,
  getDownloadURL,
  uploadBytesResumable,
  listAll,
  deleteObject,
  list
} from "firebase/storage";
import { Radio } from "@chakra-ui/react";
//antd imports
import { Alert, Progress } from "antd";

import { Typography } from "antd";

import { Checkbox, Text } from "@chakra-ui/react";

const { Title } = Typography;

function Annual_Net_Conservation() {
  //redux functions
  const dispatch = useDispatch();
  const organization_name_store = useSelector(
    (state) => state.ccaa.organization_name_store
  );

  const annual_net_conservation_store = useSelector(
    (state) => state.ccaa.annual_net_conservation_store
  );
  const annual_net_conservation_checkboxes = useSelector(
    (state) => state.ccaa.annual_net_conservation_checkboxes
  );
  const annual_net_conservation_files = useSelector(
    (state) => state.ccaa.annual_net_conservation_files
  );
  const [fileUploadProgress, setFileUploadProgress] = React.useState({
    tracking_sheet: 0,
    supporting_documents: 0,
    updated_section_7: 0
  });
  const [fileUploadStatus, setFileUploadStatus] = React.useState({
    tracking_sheet: false,
    supporting_documents: false,
    updated_section_7_file: false
  });
  const [fileNames, setFileNames] = React.useState({});
  const [updateFileNames, setUpdateFileNames] = React.useState(0);

  //file constants

  const annual_net_conservation_default_values = {
    organization_name: organization_name_store,
    conservation_measures: [],
    conservation_measures_implementation: "",
    partners_overlap: "",
    supplement_measures: [],
    additional_supplement_conservation_measures: "",
    updates_to_section_7: [],
    updated_section_7_file: ""
  };

  const annual_net_conservation_checkboxes_default_values = {
    conservation_mowing: false,
    habitat_set_asides: false,
    targeted_herbicide: false,
    seeding_or_planting: false,
    brush_removal: false,
    prescribed_burning: false,
    prescribed_grazing: false,
    overwintering_protection: false,
    spatially_focused: false,
    incorporate_pollinator: false,
    invasive_species_prevention: false,
    additional_pollinator_habitat: false,
    promote_supplemental_pollinator: false,
    none: false,
    update_section_7_yes: false,
    update_section_7_no: false
  };

  const [annual_net_conservation_values, set_annual_net_conservation_values] =
    React.useState(annual_net_conservation_default_values);
  const [
    annual_net_conservation_checkboxes_values,
    set_annual_net_conservation_checkboxes_values
  ] = React.useState(annual_net_conservation_checkboxes_default_values);

  const text_input_width = window.innerWidth * 0.5;
  const text_input_height = window.innerHeight * 0.05;
  //functions

  const handleFormSubmit = (e) => {
    e.preventDefault();
    dispatch(
      ccaa_actions.set_annual_net_conservation(annual_net_conservation_values)
    );
  };

  const handleRadioBox = (e) => {
    const { name, value } = e.target;
    //reset the array
    set_annual_net_conservation_values({
      ...annual_net_conservation_values,
      [name]: []
    });
    //add the new value
    set_annual_net_conservation_values({
      ...annual_net_conservation_values,
      [name]: [value]
    });
    if (value === "update_section_7_yes") {
      dispatch(
        ccaa_actions.set_annual_net_conservation_radio({
          name,
          value,
          checked: true
        })
      );
      dispatch(
        ccaa_actions.set_annual_net_conservation_radio({
          name,
          value: "update_section_7_no",
          checked: false
        })
      );
    } else if (value === "update_section_7_no") {
      dispatch(
        ccaa_actions.set_annual_net_conservation_radio({
          name,
          value,
          checked: true
        })
      );
      dispatch(
        ccaa_actions.set_annual_net_conservation_radio({
          name,
          value: "update_section_7_yes",
          checked: false
        })
      );
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (Array.isArray(annual_net_conservation_values[name])) {
      if (!annual_net_conservation_values[name].includes(value)) {
        set_annual_net_conservation_values({
          ...annual_net_conservation_values,
          [name]: [...annual_net_conservation_values[name], value]
        });
        dispatch(
          ccaa_actions.set_annual_net_conservation_checkboxes({ name, value })
        );
      } else {
        set_annual_net_conservation_values({
          ...annual_net_conservation_values,
          [name]: annual_net_conservation_values[name].filter(
            (item) => item !== value
          )
        });
        dispatch(
          ccaa_actions.set_annual_net_conservation_checkboxes({ name, value })
        );
      }
    } else {
      set_annual_net_conservation_values({
        ...annual_net_conservation_values,
        [name]: value
      });
    }
  };

  useEffect(() => {
    dispatch(
      ccaa_actions.set_annual_net_conservation(annual_net_conservation_values)
    );
  }, [annual_net_conservation_values]);

  useEffect(() => {
    setFileNames(annual_net_conservation_files);
  }, [annual_net_conservation_files]);

  useEffect(() => {
    setUpdateFileNames(updateFileNames + 1);
  }, [fileNames]);

  useEffect(() => {
    set_annual_net_conservation_checkboxes_values(
      annual_net_conservation_checkboxes
    );
  }, [annual_net_conservation_checkboxes]);

  useEffect(() => {
    //set organization name
    set_annual_net_conservation_values({
      ...annual_net_conservation_values,
      organization_name: organization_name_store
    });
    //dispatch(ccaa_actions.convert_to_array_conservation_measures())
    set_annual_net_conservation_values(annual_net_conservation_store);
    set_annual_net_conservation_checkboxes_values(
      annual_net_conservation_checkboxes
    );
    setFileNames({
      tracking_sheet: [],
      supporting_documents: [],
      updated_section_7_file: []
    });
    //get firebase file names
    handleFirebaseGetAllFiles("tracking_sheet");
    handleFirebaseGetAllFiles("supporting_documents");
    handleFirebaseGetAllFiles("updated_section_7_file");
    setUpdateFileNames(updateFileNames + 1);
  }, []);

  const handleFirebaseUpload = async (e, fileType) => {
    //e.preventDefault();
    if (e !== null) {
      const uploadFileName = e.name;
      const storageRef = ref(
        storage,
        `${organization_name_store}/${fileType}/${uploadFileName}`
      );
      const uploadTask = uploadBytesResumable(storageRef, e);
      setFileUploadStatus({
        ...fileUploadStatus,
        [fileType]: true
      });
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setFileUploadProgress({
            ...fileUploadProgress,
            [fileType]: Math.round(progress)
          });
          switch (snapshot.state) {
            case "paused":
              break;
            case "running":
              break;
            default:
          }
        },
        (error) => {
          switch (error.code) {
            case "storage/unauthorized":
              // User doesn't have permission to access the object
              break;
            case "storage/canceled":
              // User canceled the upload
              break;
            case "storage/unknown":
              // Unknown error occurred, inspect error.serverResponse
              break;
            default:
          }
        },
        () => {
          dispatch(
            ccaa_actions.set_annual_net_conservation_files({
              fileType,
              fileName: uploadFileName
            })
          );
          setFileUploadStatus(false);
          setUpdateFileNames(updateFileNames + 1);
        }
      );
    }
  };

  const handleFirebaseDeleteFile = async (fileType, fileName) => {
    const fileRef = ref(
      storage,
      `${organization_name_store}/${fileType}/${fileName}`
    );
    await deleteObject(fileRef);
    dispatch(
      ccaa_actions.remove_annual_net_conservation_files({ fileType, fileName })
    );
  };

  const handleFirebaseGetAllFiles = async (fileType) => {
    const listRef = ref(storage, `${organization_name_store}/${fileType}`);
    const fileList = await listAll(listRef).then((res) => {
      res.items.forEach((item) => {
        dispatch(
          ccaa_actions.set_annual_net_conservation_files({
            fileType,
            fileName: item.name
          })
        );
      });
    });
  };

  useEffect(() => {
    setUpdateFileNames(updateFileNames + 1);
  }, [fileNames]);

  useEffect(() => {
    setFileNames(annual_net_conservation_files);
  }, [annual_net_conservation_files]);

  return (
    <>
      <div className="container">
        <Title level={3}>Annual Net Conservation Benefit Contributions</Title>
        <div className="mt-2 mb-2">
          <label type="text">
            Provide a summary of adopted acres managed over the past year in the
            Agreement.
          </label>
        </div>
        <div className="mt-2 mb-2">
          <Alert
            message="Please note your responses are saved automatically"
            type="info"
            showIcon
          />
        </div>
        <form onSubmit={handleFormSubmit}>
          <div className="p-4 border-1 border-dark rounded-3 border-background">
            <div className="row">
              <div className="col-flex-util">
                <Title level={4}>
                  What conservation measures did you undertake on your adopted
                  acres in 2024?
                </Title>
                <div>
                  <Text>(check all that apply)</Text>
                </div>
                <div className="col-flex-util">
                  <div className="col-md-2">
                    <Checkbox
                      name="conservation_measures"
                      value="conservation_mowing"
                      onChange={(e) => handleInputChange(e)}
                      isChecked={
                        annual_net_conservation_checkboxes_values.conservation_mowing
                          ? annual_net_conservation_checkboxes_values.conservation_mowing
                          : false
                      }
                    >
                      Conservation Mowing
                    </Checkbox>
                  </div>
                  <div className="col-md-2">
                    <Checkbox
                      name="conservation_measures"
                      value="habitat_set_asides"
                      onChange={(e) => handleInputChange(e)}
                      isChecked={
                        annual_net_conservation_checkboxes_values.habitat_set_asides
                          ? annual_net_conservation_checkboxes_values.habitat_set_asides
                          : false
                      }
                    >
                      Habitat set-asides or idle lands
                    </Checkbox>
                  </div>
                  <div className="col-md-2">
                    <Checkbox
                      name="conservation_measures"
                      value="targeted_herbicide"
                      onChange={(e) => handleInputChange(e)}
                      isChecked={
                        annual_net_conservation_checkboxes_values.targeted_herbicide
                          ? annual_net_conservation_checkboxes_values.targeted_herbicide
                          : false
                      }
                    >
                      Targeted herbicide treatments
                    </Checkbox>
                  </div>
                  <div className="col-md-2">
                    <Checkbox
                      name="conservation_measures"
                      value="seeding_or_planting"
                      onChange={(e) => handleInputChange(e)}
                      isChecked={
                        annual_net_conservation_checkboxes_values.seeding_or_planting
                          ? annual_net_conservation_checkboxes_values.seeding_or_planting
                          : false
                      }
                    >
                      Seeding or planting of habitat
                    </Checkbox>
                  </div>
                  <div className="col-md-2">
                    <Checkbox
                      name="conservation_measures"
                      value="brush_removal"
                      onChange={(e) => handleInputChange(e)}
                      isChecked={
                        annual_net_conservation_checkboxes_values.brush_removal
                          ? annual_net_conservation_checkboxes_values.brush_removal
                          : false
                      }
                    >
                      Brush removal{" "}
                    </Checkbox>
                  </div>
                  <div className="col-md-2">
                    <Checkbox
                      name="conservation_measures"
                      value="prescribed_burning"
                      onChange={(e) => handleInputChange(e)}
                      isChecked={
                        annual_net_conservation_checkboxes_values.prescribed_burning
                          ? annual_net_conservation_checkboxes_values.prescribed_burning
                          : false
                      }
                    >
                      Prescribed burning
                    </Checkbox>
                  </div>
                  <div className="col-md-2">
                    <Checkbox
                      name="conservation_measures"
                      value="prescribed_grazing"
                      onChange={(e) => handleInputChange(e)}
                      isChecked={
                        annual_net_conservation_checkboxes_values.prescribed_grazing
                          ? annual_net_conservation_checkboxes_values.prescribed_grazing
                          : false
                      }
                    >
                      Prescribed grazing
                    </Checkbox>
                  </div>
                  <div className="col-md-2">
                    <Checkbox
                      name="conservation_measures"
                      value="overwintering_protection"
                      onChange={(e) => handleInputChange(e)}
                      isChecked={
                        annual_net_conservation_checkboxes_values.overwintering_protection
                          ? annual_net_conservation_checkboxes_values.overwintering_protection
                          : false
                      }
                    >
                      Overwintering protection measures
                    </Checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 p-4 border-1 border-dark rounded-3 border-background">
            <div className="row">
              <div className="col-flex-util">
                <Title level={4}>
                  Please upload a tracking sheet, shapefile, and/or other
                  supporting documentation of implemented conservation measures.
                </Title>
                <div>
                  <Text>
                    The Compliance Tracking template is available on the Monarch
                    CCAA Toolkit.
                  </Text>
                </div>
                <div>
                  <Text>
                    Link:{" "}
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://rightofway.erc.uic.edu/working-group-access/monarchccaatoolkit"
                    >
                      Compliance Tracking Table
                    </a>
                  </Text>
                </div>
                <div>
                  <FileUploader
                    handleChange={(e) =>
                      handleFirebaseUpload(e, "tracking_sheet")
                    }
                    name="tracking_sheet"
                  />
                  <div>
                    {fileUploadStatus["tracking_sheet"] ? (
                      <Progress
                        percent={fileUploadProgress["tracking_sheet"]}
                        status={fileUploadStatus}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="mt-2 file-component">
                    <Text className="mb-2">Uploaded Files</Text>
                    {updateFileNames && fileNames["tracking_sheet"].length > 0
                      ? fileNames["tracking_sheet"].map((file, index) => (
                          <div className="mt-2 row" key={index}>
                            <Text className="col-10">{file}</Text>
                            <button
                              className="col-2 btn btn-sm btn-danger"
                              onClick={(e) =>
                                handleFirebaseDeleteFile("tracking_sheet", file)
                              }
                            >
                              Delete
                            </button>
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 p-4 border-1 border-dark rounded-3 border-background">
            <div className="row">
              <div className="col-flex-util">
                <Title level={4}>
                  Describe the implementation of conservation measures and
                  adopted acres managed. Verify if these are the same as in the
                  initial application, or if any changes occurred. Summarize any
                  unforeseen or changed circumstances that impacted annual
                  contribution.
                </Title>
                <div>
                  <textarea
                    rows={10}
                    width={text_input_width}
                    height={text_input_height}
                    type="text"
                    className="form-control"
                    id="conservation_measures_implementation"
                    placeholder=""
                    name="conservation_measures_implementation"
                    defaultValue={
                      annual_net_conservation_store.conservation_measures_implementation
                        ? annual_net_conservation_store.conservation_measures_implementation
                        : ""
                    }
                    onBlur={handleInputChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 p-4 border-1 border-dark rounded-3 border-background">
            <div className="row">
              <div className="col-flex-util">
                <Title level={4}>
                  Describe whether your adopted acres contained overlap with
                  another CCAA Partners adopted acres. If so, name which
                  Partners have overlap and estimate the number of acres or
                  percentage of overlap
                </Title>
                <div>
                  <Text>
                    Link:{" "}
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://monarch-ccaa-tools.netlify.app/"
                    >
                      Partners by State Tool
                    </a>
                  </Text>
                </div>
                <div>
                  <textarea
                    rows={10}
                    width={text_input_width}
                    height={text_input_height}
                    type="text"
                    className="form-control"
                    id="partners_overlap"
                    placeholder=""
                    name="partners_overlap"
                    defaultValue={
                      annual_net_conservation_store.partners_overlap
                        ? annual_net_conservation_store.partners_overlap
                        : ""
                    }
                    onBlur={handleInputChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 p-4 border-1 border-dark rounded-3 border-background">
            <div className="row">
              <div className="col-flex-util">
                <Title level={4}>
                  What supplemental measures did you undertake as part of your
                  CCAA implementation in 2024?
                </Title>
                <div>
                  <Text>(check all that apply)</Text>
                </div>
                <div className="col-flex-util">
                  <div className="col-md-2">
                    <Checkbox
                      name="supplement_measures"
                      value="spatially_focused"
                      onChange={(e) => handleInputChange(e)}
                      isChecked={
                        annual_net_conservation_checkboxes_values.spatially_focused
                          ? annual_net_conservation_checkboxes_values.spatially_focused
                          : false
                      }
                    >
                      Spatially-focused conservation delivery
                    </Checkbox>
                  </div>
                  <div className="col-md-2">
                    <Checkbox
                      name="supplement_measures"
                      value="incorporate_pollinator"
                      onChange={(e) => handleInputChange(e)}
                      isChecked={
                        annual_net_conservation_checkboxes_values.incorporate_pollinator
                          ? annual_net_conservation_checkboxes_values.incorporate_pollinator
                          : false
                      }
                    >
                      Incorporate pollinator habitat IVM objectives
                    </Checkbox>
                  </div>
                  <div className="col-md-2">
                    <Checkbox
                      name="supplement_measures"
                      value="invasive_species_prevention"
                      onChange={(e) => handleInputChange(e)}
                      isChecked={
                        annual_net_conservation_checkboxes_values.invasive_species_prevention
                          ? annual_net_conservation_checkboxes_values.invasive_species_prevention
                          : false
                      }
                    >
                      Invasive species prevention best management practices
                    </Checkbox>
                  </div>
                  <div className="col-md-2">
                    <Checkbox
                      name="supplement_measures"
                      value="additional_pollinator_habitat"
                      onChange={(e) => handleInputChange(e)}
                      isChecked={
                        annual_net_conservation_checkboxes_values.additional_pollinator_habitat
                          ? annual_net_conservation_checkboxes_values.additional_pollinator_habitat
                          : false
                      }
                    >
                      Additional pollinator habitat monitoring
                    </Checkbox>
                  </div>
                  <div className="col-md-2">
                    <Checkbox
                      name="supplement_measures"
                      value="promote_supplemental_pollinator"
                      onChange={(e) => handleInputChange(e)}
                      isChecked={
                        annual_net_conservation_checkboxes_values.promote_supplemental_pollinator
                          ? annual_net_conservation_checkboxes_values.promote_supplemental_pollinator
                          : false
                      }
                    >
                      Promote supplemenal pollinator conservation
                    </Checkbox>
                  </div>
                  <div className="col-md-2">
                    <Checkbox
                      name="supplement_measures"
                      value="none"
                      onChange={(e) => handleInputChange(e)}
                      isChecked={
                        annual_net_conservation_checkboxes_values.none
                          ? annual_net_conservation_checkboxes_values.none
                          : false
                      }
                    >
                      None
                    </Checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 p-4 border-1 border-dark rounded-3 border-background">
            <div className="row">
              <div className="col-flex-util">
                <Title level={4}>
                  Provide additional detail on any supplemental conservation
                  measures implemented in 2024. Verify if these are the same as
                  in the initial application, or if any changes occurred.
                </Title>
                <div>
                  <Text>
                    The Supplemental Conservation Measures Guidance document is
                    available on the Monarch CCAA Toolkit.
                  </Text>
                </div>
                <div>
                  <Text>
                    Link:{" "}
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href=" https://rightofway.erc.uic.edu/working-group-access/monarchccaatoolkit"
                    >
                      Guidance Document
                    </a>
                  </Text>
                </div>
                <div>
                  <textarea
                    rows={10}
                    width={text_input_width}
                    height={text_input_height}
                    type="text"
                    className="form-control"
                    id="additional_supplement_conservation_measures"
                    placeholder=""
                    name="additional_supplement_conservation_measures"
                    defaultValue={
                      annual_net_conservation_store.additional_supplement_conservation_measures
                        ? annual_net_conservation_store.additional_supplement_conservation_measures
                        : ""
                    }
                    onBlur={handleInputChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 p-4 border-1 border-dark rounded-3 border-background">
            <div className="row">
              <div className="col-flex-util">
                <Title level={4}>
                  Upload the appropriate documentation for the previous question
                  here if seeking a fee discount based on supplemental measures
                  completed.
                </Title>
                <div>
                  <FileUploader
                    handleChange={(e) =>
                      handleFirebaseUpload(e, "supporting_documents")
                    }
                    name="supporting_documents"
                  />
                  <div>
                    {fileUploadStatus["supporting_documents"] ? (
                      <Progress
                        percent={fileUploadProgress["supporting_documents"]}
                        status={fileUploadStatus}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="mt-2 file-component">
                    <Text className="mb-2">Uploaded Files</Text>
                    {updateFileNames &&
                    fileNames["supporting_documents"].length > 0
                      ? fileNames["supporting_documents"].map((file, index) => (
                          <div className="mt-2 row" key={index}>
                            <Text className="col-10">{file}</Text>
                            <button
                              className="col-2 btn btn-sm btn-danger"
                              onClick={(e) =>
                                handleFirebaseDeleteFile(
                                  "supporting_documents",
                                  file
                                )
                              }
                            >
                              Delete
                            </button>
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 p-4 border-1 border-dark rounded-3 border-background">
            <div className="row">
              <div className="col-flex-util">
                <Title level={4}>
                  Have you made any updates to your Section 7 species list or
                  Avoidance & Minimization Measures (AMMs)?
                </Title>
                <div className="col-flex-util">
                  <div className="col-md-2">
                    <Radio
                      name="updates_to_section_7"
                      value="update_section_7_yes"
                      onChange={(e) => handleRadioBox(e)}
                      isChecked={
                        annual_net_conservation_checkboxes_values.update_section_7_yes
                          ? annual_net_conservation_checkboxes_values.update_section_7_yes
                          : false
                      }
                    >
                      Yes
                    </Radio>
                  </div>
                  <div className="col-md-2">
                    <Radio
                      name="updates_to_section_7"
                      value="update_section_7_no"
                      onChange={(e) => handleRadioBox(e)}
                      isChecked={
                        annual_net_conservation_checkboxes_values.update_section_7_no
                          ? annual_net_conservation_checkboxes_values.update_section_7_no
                          : false
                      }
                    >
                      No
                    </Radio>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 mb-4 p-4 border-1 border-dark rounded-3 border-background">
            <div className="row">
              <div className="col-flex-util">
                <Title level={4}>
                  Upload your updated Section 7 documentation here if applicable
                </Title>
                <div>
                  <FileUploader
                    handleChange={(e) =>
                      handleFirebaseUpload(e, "updated_section_7_file")
                    }
                    name="updated_section_7_file"
                  />
                  <div>
                    {fileUploadStatus["updated_section_7_file"] ? (
                      <Progress
                        percent={fileUploadProgress["updated_section_7_file"]}
                        status={fileUploadStatus}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="mt-2 file-component">
                    <Text className="mb-2">Uploaded Files</Text>
                    {updateFileNames &&
                    fileNames["updated_section_7_file"].length > 0
                      ? updateFileNames &&
                        fileNames["updated_section_7_file"].map(
                          (file, index) => (
                            <div className="mt-2 row" key={index}>
                              <Text className="col-10">{file}</Text>
                              <button
                                className="col-2 btn btn-sm btn-danger"
                                onClick={(e) =>
                                  handleFirebaseDeleteFile(
                                    "updated_section_7_file",
                                    file
                                  )
                                }
                              >
                                Delete
                              </button>
                            </div>
                          )
                        )
                      : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default Annual_Net_Conservation;
